import { gql } from '@apollo/client';

const REMOVE_IMAGE_ITEM = gql`
  mutation removeImageItem($orderGroupId: Int!, $productId: ID!) {
    removeFromImageBank(orderGroupId: $orderGroupId, productId: $productId)
  }
`;

export default REMOVE_IMAGE_ITEM;
